const fileTypeByExtension: Record<string, { label: string; tone: string }> = {
  cs: { label: "C#", tone: "blue" },
  css: { label: "#", tone: "purple" },
  graphql: { label: "G", tone: "pink" },
  hcl: { label: "TF", tone: "purple" },
  html: { label: "<>" , tone: "orange" },
  js: { label: "JS", tone: "yellow" },
  json: { label: "{}", tone: "yellow" },
  jsx: { label: "JS", tone: "cyan" },
  md: { label: "M", tone: "slate" },
  proto: { label: "P", tone: "green" },
  py: { label: "PY", tone: "blue" },
  scss: { label: "S", tone: "pink" },
  sql: { label: "DB", tone: "blue" },
  tf: { label: "TF", tone: "purple" },
  ts: { label: "TS", tone: "blue" },
  tsx: { label: "TS", tone: "cyan" },
  yaml: { label: "Y", tone: "red" },
  yml: { label: "Y", tone: "red" },
};

function fileType(path: string, language?: string) {
  const name = path.split("/").at(-1) ?? path;
  const extension = name.includes(".") ? name.split(".").at(-1)!.toLowerCase() : "";
  if (fileTypeByExtension[extension]) return fileTypeByExtension[extension]!;
  if (language === "terraform") return fileTypeByExtension.tf!;
  if (language === "csharp") return fileTypeByExtension.cs!;
  if (language === "typescript") return fileTypeByExtension.ts!;
  return { label: "·", tone: "slate" };
}

export function FileTypeIcon({ compact = false, language, path }: { compact?: boolean; language?: string; path: string }) {
  const type = fileType(path, language);
  return (
    <span
      aria-hidden="true"
      className={`file-type-icon file-type-${type.tone}${compact ? " compact" : ""}`}
    >
      {type.label}
    </span>
  );
}

